import {cva} from 'class-variance-authority';

export const paperVariants = cva('rounded-soft p-4', {
  variants: {
    variant: {
      white: 'bg-white shadow-rounded',
      neutral: 'bg-neutral-light',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
});
